"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ClientModel = require("./ClientModel");

var _ClientModel2 = _interopRequireDefault(_ClientModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClientsModel = function (_Client) {
    _inherits(ClientsModel, _Client);

    function ClientsModel(observers, id, request) {
        _classCallCheck(this, ClientsModel);

        var _this = _possibleConstructorReturn(this, (ClientsModel.__proto__ || Object.getPrototypeOf(ClientsModel)).call(this, observers, id, request));

        _this.Clients = [];
        return _this;
    }
    /**
     * Liste von Mandanten
     * @type {Array} of Clients
     */


    _createClass(ClientsModel, null, [{
        key: "GetClients",
        value: function GetClients() {
            var me = this;
            this.request.setRequest("/Clients");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        var _result = data.Data;
                        for (var i = 0; i < _result.length; i++) {
                            var client = {
                                Id: _result.Id,
                                Description: _result.Description
                            };
                            me.Clients.push(client);
                        }
                    }
                }
                var id = me.Id ? me.Id : "Clients";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return ClientsModel;
}(_ClientModel2.default);

exports.default = ClientsModel;